import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import config from "../config/config";
import {
  Provider as AppBridgeProvider,
  ClientRouter,
  RoutePropagator,
} from "@shopify/app-bridge-react";
import ContentApps from "./ContentApps";
import YearlyPlanModal from "./feature/yearly/YearlyPlanModal";

const App = (props) => {
  useEffect(() => {
    const stamp = new Date().getTime();
    const script = document.createElement("script");

    script.src = `https://apps.synctrack.io/helpdesk/plugin.js?appId=2&v=${stamp}`;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const { location, history } = props;
  const url = new URL(`https://apps.synctrack.io${location.search}`);
  const host = url.searchParams.get("host");
  let domain = new URL(`https://${config.shop}`);
  domain = domain.hostname;
  const configApp = {
    apiKey: config.apiKey,
    host: host,
    forceRedirect: true,
  };
  console.log(configApp);
  return (
    <div>
      <div>
        <ContentApps />
      </div>
    </div>
  );
};

export default withRouter(App);
